module.exports = __webpack_public_path__ + "static/media/11-min.jpg.726dd1ea.webp";